<script setup lang="ts">
    import type { DialogTitleProps } from 'reka-ui';
    import type { HTMLAttributes } from 'vue';
    import { reactiveOmit } from '@vueuse/core';
    import { DialogTitle } from 'reka-ui';
    import { cn } from '../utils';

    const props = defineProps<DialogTitleProps & { class?: HTMLAttributes['class'] }>();

    const delegatedProps = reactiveOmit(props, 'class', 'as');
</script>

<template>
    <DialogTitle
        data-slot="sheet-title"
        as="div"
        :class="cn('text-base font-semibold', props.class)"
        v-bind="delegatedProps"
    >
        <slot />
    </DialogTitle>
</template>
